import apiOffice from "../../axios/apiOffice";
import setTokenUser from "../../office/tokens/refreshTokenUser";
import setTokenRelations from "../../office/tokens/refreshTokenRelations";

export async function getNotificationsBd() {
  try {
    const response = await apiOffice.get("/communications/my-communications");
    let notifications = response.data.Communications;
    // console.log (notifications)
    return notifications;
  } catch (error) {
    // console.error("Error al obtener notificaciones:", error);
    if (error.response.status === 500) {
      if (error.response.data.message === "Token de usuario expirado") {
        let asd = await setTokenUser();
        if (asd) {
          getNotificationsBd();
        }
      }
      if (error.response.data.message === "Token de representante expirado") {
        let asd = await setTokenRelations();
        if (asd) {
          getNotificationsBd();
        }
      }
    }
  }
}

export async function setNotificationRead(id) {
  try {
    let response = await apiOffice.patch(`/communications/${id}/mark-as-read`);
    return { status: response.status, message: response.data.message };
  } catch (error) {
    // console.error("Error al actualizar notificacion leida:", error);
    if (error.response.status === 500) {
      if (error.response.data.message === "Token de usuario expirado") {
        let asd = await setTokenUser();
        if (asd) {
          getNotificationsBd();
        }
      }
      if (error.response.data.message === "Token de representante expirado") {
        let asd = await setTokenRelations();
        if (asd) {
          getNotificationsBd();
        }
      }
    } else {
      return { status: error.response.status };
    }
  }
}
